// Module
var code = "<div class=\"widget\"> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"close($event)\"><span>&times;</span></button> <h1 class=\"modal-title\" translate>{{ 'app.shared.calendar.filter_calendar' }}</h1> </div> <div class=\"modal-body widget-content calendar-filter calendar-filter-aside\"> <ng-include src=\"'/calendar/filter.html'\"></ng-include> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/calendar/filterAside.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;